export default {
    upgrade: {
        title: '选择适合您的计划',
        subtitle: '解锁专业功能，提升您的生产力',
        pickYourPlan: '选择计划',
        subscribeSuccess: '订阅成功',
        contactSales: '请联系我们的销售团队以获取企业解决方案。',
        enterpriseRestriction: '当前仅支持个人用户订阅付费套餐，企业用户如需使用请联系销售团队获取专属方案。',
        freeplanActivated: '基础版已激活',
        planNotFound: '未找到所选套餐',
        alreadySubscribed: '您已经订阅了此计划',
        priceIdNotConfigured: '该套餐暂未配置支付信息',
        paymentInitFailed: '支付初始化失败，请重试',
        freeTrialCard: {
            title: '免费',
            titleSuffix: '试用 14 天',
            description: '无需信用卡',
            price: '包含 10,000 试用 Credits*',
            action: '开始免费试用',
            featuresTitle: '通常可用于：',
            features: {
                patentApplicationDraft: '≈ 1 份专利申请文件初稿',
                inventionDisclosures: '或≈ 2 份发明交底书',
                officeActionResponses: '或≈ 2 份审查意见答复',
                claimsDrawingsMore: '支持权利要求、附图等',
                efficiency: '专利撰写提速最高 50% • 专利制图提速最高 90%',
            },
        },
        maxPlan: {
            planName: 'Max',
            activeStatus: '生效中',
            cancelingStatus: '取消中',
            features: {
                unlimitedDrafting: '不限量创建专利撰写文档',
                priorityWorkflow: '适合高频撰写的优先工作流',
            },
            billing: {
                title: '账单与支付',
                cancelPlan: '取消套餐',
                price: '价格',
                period: '计费周期',
                renewalDate: '续费日期',
                cancelDate: '取消日期',
                month: '月',
                year: '年',
            },
            cancel: {
                title: '取消 Max 套餐',
                description: '取消后，您的 Max 套餐会继续生效到当前计费周期结束。',
                keepPlan: '保留套餐',
                confirm: '确认取消',
                processing: '取消中...',
                otherPlaceholder: '请告诉我们原因',
                noSubscription: '未找到有效的 Max 订阅。',
                success: '订阅已取消，您的 Max 套餐会继续生效至 {date}。',
                failed: '取消订阅失败，请重试。',
                reasons: {
                    tooExpensive: '价格太贵',
                    missingFeatures: '缺少功能',
                    lowQuality: '质量较低',
                    switchedToAnotherService: '切换到其他服务',
                    other: '其他',
                },
            },
        },
        plans: {
            period: {
                monthly: ' / 月',
                yearly: ' / 年',
            },
            basic: {
                name: '基础版',
                subtitle: '入门必备核心功能',
                price: '免费',
                description: '适合正在探索 AI 专利撰写的发明人和专利律师。',
                button: '立即开始',
                featuresHeader: '方案功能：',
                features: {
                    patentDraftingAgents: '访问专利撰写智能体，包括',
                    limitedHiroPrompts: 'AI 编辑，可有限使用 Hiro prompts',
                },
            },
            pro: {
                name: 'Pro',
                subtitle: '专业人士的高级工具',
                description: '加速专利申请全流程工作流',
                button: '订阅 Pro',
                moduleName: '专业版（月付/年付）',
                yearlySavings: '年付更优惠',
                featuresHeader: '全球专利申请全流程撰写辅助功能：',
                features: {
                    additionalHiroMessages: '额外 Hiro Copilot 对话次数',
                    fullDocumentExports: '完整文档导出',
                    disclosure1Doc: '发明披露文件生成 ({n}篇)',
                    application1Doc: '专利申请文件撰写 ({n}篇)',
                    oar1Doc: '审查意见答复 ({n}篇)',
                },
            },
            max: {
                name: 'Max',
                subtitle: '高频撰写的不限量方案',
                description: '撰写与审查答复工作流不限量使用。',
                button: '订阅 Max',
                moduleName: 'Max（月付/年付）',
                yearlySavings: '年付更优惠',
                features: {
                    unlimitedPatentDraftingAgents: '专利撰写智能体不限量使用',
                },
            },
            enterprise: {
                name: '企业版',
                subtitle: '为组织提供全面的智能支持',
                price: '联系我们',
                description: '面向整个团队或组织扩展专利运营能力。',
                button: '预约演示',
                featuresHeader: '包含 Max 全部功能，并额外提供：',
                features: {
                    teamUsageHeader: '团队用量与管理',
                    teamPooledCredits: '团队共享 credits，并支持自定义分配',
                    adminConsole: '用于账单、用量和用户管理的管理员控制台',
                    collaborationHeader: '协作',
                    sharedWorkspaces: '共享工作区和团队项目',
                    teamWideIntelligence: '团队级智能能力分发',
                    governanceHeader: '治理与安全',
                    ssoSecurity: 'SSO 和企业级安全控制',
                    rolePermissions: '面向用户和工作区的角色权限',
                    fileUploadControls: '文件上传控制',
                    privateIncognito: '私密无痕模式',
                    serviceHeader: '服务与成功',
                    dedicatedSupport: '专属客户支持',
                    slaMonitoring: '99.9% SLA 和主动监控',
                },
                benefits: {
                    expandedSearch: '检索量扩容',
                    humanInLoop: '人机协同校验',
                    advancedEditor: '高级在线编辑器',
                    workspaceIntegration: '团队工作空间集成',
                    professionalExport: '专业文档导出',
                    evenMoreHiro: '更多 Hiro Copilot 对话次数',
                    ssoSecurity: 'SSO 单点登录与高级安全配置',
                    dedicatedSuccess: '专属客户成功经理',
                },
            },
            api: {
                name: 'Open platform',
                subtitle: '开发者优先的集成方案',
                price: '定制化报价',
                description: '将专利智能嵌入您现有的基础设施。',
                button: '获取 API Key',
                featuresHeader: '开发者能力：',
                features: {
                    apisHeader: '面向自定义工作流的 APIs',
                    dataAiApis: '覆盖专利、生命科学、研发和市场情报的 300+ 数据 APIs 与 60+ AI agent APIs',
                    widgetsHeader: '可嵌入 UI Widgets',
                    dropInWidgets: '将图表、洞察和 AI 工作流嵌入您的产品，无需重建',
                    mcpHeader: '面向企业 AI 的 MCP Servers',
                    mcpServers: '通过任何 MCP 兼容客户端连接可信的 PatSnap 工具，包括 Claude Desktop 和 Cursor',
                    skillsHeader: 'Agent Skills 与 SDKs',
                    agentSkillsSdks: '使用 LangChain、OpenClaw、CrewAI 等框架构建并编排工作流',
                    playgroundHeader: '交互式开发者 Playground',
                    developerPlayground: '在一个地方探索场景演示、测试 APIs、构建 widgets 并生成代码',
                },
            },
            features: {
                hiroMessages: 'Hiro Copilot 对话交互',
                disclosure: '发明披露文件生成',
                application: '专利申请文件撰写',
                oar: '审查意见答复',
                patentDrafting: '专利撰写',
                disclosureUnlimited: '发明披露文件生成（不限量）',
                patentDraftUnlimited: '专利申请文件撰写（不限量）',
                oarDraftUnlimited: '审查意见答复（不限量）',
                templateInstructionStyle: '模板 / 指令 / 格式自定义',
                customerTemplateInstructionStyle: '自定义模板 / 指令 / 风格',
                exportWordDocuments: '将撰写内容导出为 Word 文档',
                wordWpsPlugin: '包含 Eureka Pro（$200）：完整使用所有 Eureka 智能体',
            },
        },
        billingCycle: {
            monthly: '月付',
            yearly: '年付',
            shortSaveAmount: '省 ${amount}',
            saveAmount: '年付节省 ${amount}',
        },
        features: '方案功能',
        benefits: '权益',
        currentPlan: '当前方案',
        recommend: '最受欢迎',
        audienceTabs: {
            label: '定价对象',
            individual: '个人',
            teams: '团队与企业',
        },
        comparison: {
            title: '对比套餐',
            plans: {
                guest: '访客',
                free: '基础版',
                pro: 'Pro',
                max: 'Max',
                enterprise: '企业版',
            },
            categories: {
                agent: '核心 Agent',
                features: '其他功能',
                ai: 'AI 工具',
                security: '安全与管控',
                collaboration: '企业协作',
            },
            rows: {
                disclosure: '发明披露文件生成',
                application: '专利申请文件撰写',
                oar: '审查意见答复',
                templates: '模板',
                instructions: '指令',
                styles: '风格',
                draftingCenter: '撰写中心',
                officePlugin: 'Word 插件（即将发布）',
                aiChat: 'Hiro',
                chatLimitN: '{n} 次/天',
                chatLimit500: '500 次/天',
                moreUsage: '更高的次数',
                evenMoreUsage: '定制次数',
                createProject: '创建项目',
                exportProject: '导出项目',
                sharedAssets: '模板/指令/风格共享',
                enterpriseManagement: '企业管理',
            },
        },
    },
    pricing: {
        payment: {
            creatingSession: '正在创建支付会话...',
            errors: {
                createSessionFailed: '创建支付会话失败，请检查当前账号类型。',
                verifyFailed: '验证支付状态失败',
                verificationFailed: '支付验证失败',
                verificationError: '验证过程中发生错误',
                invalidCallback: '无效的支付回调',
                noPriceId: '价格信息未配置',
            },
        },
    },
};
